import { isAdmin } from "library/authorization"
import { hasAnyDemand } from "lib/authorization/has-any-demand"
import { getCurrentUser } from "controller/getCurrentUser"
import {
    AUTHORING_EDIT_SCHEDULES_DEMAND,
    AUTHORING_REVIEW_SCHEDULES_DEMAND,
} from "authoring/lib/constants/authoring-permissions.mjs"

export function useHasAmendsAccess() {
    const currentUser = getCurrentUser.useResults()
    const currentUserId = currentUser?.id ?? currentUser?.UserId ?? null
    return (amends = {}) => hasAmendsAccess(amends, { currentUserId })
}

export function hasAmendsAccess(amends = {}, { currentUserId = null } = {}) {
    if (isAdmin()) return true
    if (hasAmendsPermission()) return true
    if (isCreator(amends, { currentUserId })) return true
    return false
}

function hasAmendsPermission() {
    return hasAnyDemand([AUTHORING_EDIT_SCHEDULES_DEMAND, AUTHORING_REVIEW_SCHEDULES_DEMAND])
}

function isCreator(amends = {}, { currentUserId = null } = {}) {
    const { userId } = amends
    if (!userId) return false
    if (!currentUserId) return false

    return userId === currentUserId
}
